import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/toaster';
import { ProjectsPage, ProjectPage } from './features/projects';
import { SettingsDialogProvider } from './contexts/SettingsDialogContext';
import { LoginPage, SignupPage, ActivatePage, ForgotPasswordPage, ResetPasswordPage } from './features/auth';
import { WelcomePage } from './features/welcome';
import { AdminPage } from './features/admin';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { LegacyPrefixRedirect } from './components/LegacyPrefixRedirect';
import { NavbarToolbarProvider } from './contexts/NavbarToolbarContext';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import { AppShell } from './features/shell';
import {
  LibraryLayout,
  LibraryLandingPage,
  LibraryDocumentPage,
  LibraryQuestionPage,
  LibrarySearchPage,
} from './features/library';
import { AskLayout } from './features/chat/AskLayout';
import { AskEmptyPage } from './features/chat/AskEmptyPage';
import ChatPage from './features/chat/ChatPage';
import { DeskLayout, DeskPage } from './features/desk';
import { OpinionsLayout, OpinionsListPage, OpinionArticlePage } from './features/opinions';
import { ASK_PATH, DESK_PATH, LIBRARY_PATH, OPINIONS_PATH } from './constants/appRoutes';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <SettingsDialogProvider>
          <NavbarToolbarProvider>
          <BreadcrumbProvider>
          <div className="App app-gradient-bg">
            <main className="flex-1 min-h-0 overflow-hidden flex flex-col">
              <Routes>
              <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                <Route path={LIBRARY_PATH} element={<LibraryLayout />}>
                  <Route index element={<LibraryLandingPage />} />
                  <Route path="search" element={<LibrarySearchPage />} />
                  <Route path="documents/:id" element={<LibraryDocumentPage />} />
                  <Route path="questions/:id" element={<LibraryQuestionPage />} />
                  <Route path="*" element={<Navigate to={LIBRARY_PATH} replace />} />
                </Route>
                <Route path={ASK_PATH} element={<AskLayout />}>
                  <Route index element={<AskEmptyPage />} />
                  <Route path=":sessionId" element={<ChatPage />} />
                </Route>
                <Route path="/library-alt/*" element={<Navigate to={LIBRARY_PATH} replace />} />
                <Route path="/library-alt" element={<Navigate to={LIBRARY_PATH} replace />} />
                <Route path={DESK_PATH} element={<DeskLayout />}>
                  <Route index element={<DeskPage />} />
                </Route>
                {/* Admin-only for now: the KB browser is an admin surface;
                    opinion content reaches users via RAG citations. */}
                <Route
                  path={OPINIONS_PATH}
                  element={
                    <AdminRoute>
                      <OpinionsLayout />
                    </AdminRoute>
                  }
                >
                  <Route index element={<OpinionsListPage />} />
                  <Route path=":slug" element={<OpinionArticlePage />} />
                </Route>
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/projects/:id" element={<ProjectPage />} />
                <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
                <Route path="/wiki/*" element={<LegacyPrefixRedirect fromPrefix="/wiki" toPrefix={LIBRARY_PATH} />} />
                <Route path="/wiki" element={<Navigate to={LIBRARY_PATH} replace />} />
                <Route path="/chats/*" element={<LegacyPrefixRedirect fromPrefix="/chats" toPrefix={ASK_PATH} />} />
                <Route path="/chats" element={<Navigate to={ASK_PATH} replace />} />
              </Route>
              <Route path="/welcome" element={<ProtectedRoute><WelcomePage /></ProtectedRoute>} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/activate" element={<ActivatePage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="*" element={<Navigate to={ASK_PATH} replace />} />
              </Routes>
            </main>
            <Toaster />
          </div>
          </BreadcrumbProvider>
          </NavbarToolbarProvider>
          </SettingsDialogProvider>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
